import { useState } from 'react';
import { useVersion } from '../context/VersionContext';
import { VersionHistoryModal } from './VersionHistoryModal';

/** Klickbare Versionsanzeige (Footer) → öffnet den Versionsverlauf. */
export function VersionBadge({ className = '' }: { className?: string }) {
  const { running, refresh } = useVersion();
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => { setOpen(true); void refresh(); }}
        title="Versionsverlauf anzeigen"
        className={`text-sm underline decoration-dotted underline-offset-2 hover:opacity-80 transition-opacity ${className}`}
      >
        v{running}
      </button>
      {open && <VersionHistoryModal onClose={() => setOpen(false)} />}
    </>
  );
}
